(function () {
  const CART_URL_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  let refreshTimeout;

  function refreshCartIconBubble() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;

    const sectionUrl = `${window.location.pathname}?section_id=cart-icon-bubble`;

    return fetch(sectionUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const section = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('.shopify-section');

        if (section) {
          cartIcon.innerHTML = section.innerHTML;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function scheduleCartIconRefresh() {
    clearTimeout(refreshTimeout);
    refreshTimeout = setTimeout(refreshCartIconBubble, 100);
  }

  function wrapSlideCartCallback(callbackName) {
    const existingCallback = window[callbackName];

    window[callbackName] = function () {
      scheduleCartIconRefresh();
      if (typeof existingCallback === 'function') {
        return existingCallback.apply(this, arguments);
      }
    };
  }

  ['SLIDECART_UPDATED', 'SLIDECART_ADD_TO_CART', 'SLIDECART_REMOVED_FROM_CART'].forEach(wrapSlideCartCallback);

  function isCartRequest(url) {
    if (!url) return false;
    return CART_URL_PATTERN.test(String(url));
  }

  const originalFetch = window.fetch;

  if (typeof originalFetch === 'function') {
    window.fetch = function (...args) {
      const requestUrl = args[0]?.url || args[0];

      return originalFetch.apply(this, args).then((response) => {
        if (isCartRequest(requestUrl) && response.ok) {
          scheduleCartIconRefresh();
        }

        return response;
      });
    };
  }

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__cartIconRequestUrl = url;
    return originalOpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (isCartRequest(this.__cartIconRequestUrl)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) {
          scheduleCartIconRefresh();
        }
      });
    }

    return originalSend.apply(this, args);
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleCartIconRefresh);
    }
  });
})();
